import React, { useContext } from 'react';
import './CategoryVouchers.css';
import ProductVoucher from '../../ProductVoucher/ProductVoucher.jsx';
import AddToCartButtons from '../../AddToCart/AddToCartButtons.jsx';
import PropTypeShapes from '../../../services/Constants/PropTypeShapes.jsx';
import VouchersDisplay from '../../Vouchers/VouchersDisplay.jsx';
import { Category } from '../../../services/Constants/ObjectDefinitions.js';
import StockStatus from '../../../services/Constants/StockStatus.js';
import CrossSellVoucher from '../../CrossSellVoucher/CrossSellVoucher.jsx';
import { ConfigContext } from '../../../services/context/ConfigContext.js';
import { SubscriptionDetailsContext } from '../../../services/context/SubscriptionDetailsContext.js';

/**
 * @param {object} props - the props of the component
 * @param {Category} props.category - the category to display
 * @returns {JSX.Element} CategoryVouchers Component
 */
export default function CategoryVouchers({ category }) {
  const config = useContext(ConfigContext);
  const isEmpty = !category;
  const subscriptionDetails = useContext(SubscriptionDetailsContext);

  const skeletonVouchers = [
    0,
    1,
    2,
  ];

  const sortVouchersForSubscribedUser = categoryVendors => {
    if (categoryVendors?.isClubCategory && subscriptionDetails?.isSubscribed) {
      return categoryVendors
        .filter(vendor => vendor.vouchers?.some(voucher => voucher.stock.status === StockStatus.inStock
        && voucher.promotionTag?.toString() === config.frontend.general.subscriptionPromotionTag.id))
        .map(vendor => (
          <CrossSellVoucher
            key={ vendor.id }
            voucher={ vendor.vouchers.find(voucher => voucher.stock.status === StockStatus.inStock) }
            actionItem={ <AddToCartButtons voucher={ vendor.vouchers.find(voucher => voucher.stock.status === StockStatus.inStock) } /> }
            descriptionType='buyNow'
          />
        ));
    }

    return categoryVendors
      .filter(vendor => vendor.vouchers?.some(voucher => voucher.stock.status === StockStatus.inStock))
      .map(vendor => (
        <CrossSellVoucher
          key={ vendor.id }
          voucher={ vendor.vouchers.find(voucher => voucher.stock.status === StockStatus.inStock) }
          actionItem={ <AddToCartButtons voucher={ vendor.vouchers.find(voucher => voucher.stock.status === StockStatus.inStock) } /> }
          descriptionType='buyNow'
        />
      ));
  };

  return (
    <VouchersDisplay
      title={
        <h3 className={ `category-vouchers-header ${isEmpty ? 'empty skeleton-loader' : ''}` }>
          {isEmpty ? null : `${category.name} vouchers`}
        </h3>
      }
      vouchers={ isEmpty ? [] : sortVouchersForSubscribedUser(category.vendors) }
      isLoading={ isEmpty }
      onLoading={ skeletonVouchers.map(number => <ProductVoucher key={ number } />) }
    />
  );
}

CategoryVouchers.propTypes = { category: PropTypeShapes.category };
